// NUWAY brand marks (logo 560). Each comes in two versions: the plain one for light
// backgrounds and "-dark" (warm-white lines) for dark ones. The yellow dot never changes,
// so never invert these with a CSS filter — pick the right file instead.
import horizontal from "assets/images/logo/nuway-logo-horizontal.svg";
import horizontalDark from "assets/images/logo/nuway-logo-horizontal-dark.svg";
import symbol from "assets/images/logo/nuway-symbol.svg";
import symbolDark from "assets/images/logo/nuway-symbol-dark.svg";

/** The symbol alone — avatars, drawer headers, "Powered by". */
export const nuwaySymbol = (dark?: boolean): string =>
  dark ? symbolDark : symbol;

/** Symbol + wordmark side by side — page headers. At least 120 px wide. */
export const nuwayHorizontalLogo = (dark?: boolean): string =>
  dark ? horizontalDark : horizontal;
